/* FlowX ad landing page — Shop all: category chips, sort, show more.
   Everything is already in the DOM (up to 250 products), so filtering and
   sorting are instant and never reload the page. ?cat= and ?sort= are kept in
   the URL so a filtered view can be linked from an ad. */
(function () {
  if (customElements.get('adlp-shop-all')) return;

  class AdlpShopAll extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-adlp-grid]');
      if (!this.grid) return;

      this.items = Array.from(this.grid.querySelectorAll('[data-adlp-item]'));
      this.chips = Array.from(this.querySelectorAll('[data-adlp-chip]'));
      this.sortSelect = this.querySelector('[data-adlp-sort]');
      this.refineBtn = this.querySelector('[data-adlp-refine]');
      this.chipWrap = this.refineBtn
        ? document.getElementById(this.refineBtn.getAttribute('aria-controls'))
        : null;
      this.countEl = this.querySelector('[data-adlp-count]');
      this.emptyEl = this.querySelector('[data-adlp-empty]');
      this.moreBtn = this.querySelector('[data-adlp-more]');
      this.perPage = parseInt(this.dataset.perPage, 10) || 12;

      // Chip membership: { 'chains': Set(['123', '456']), ... } from the JSON
      // lists the section prints for each chip collection.
      this.members = {};
      document.querySelectorAll('[data-adlp-members]').forEach((el) => {
        try {
          this.members[el.dataset.adlpMembers] = new Set(JSON.parse(el.textContent).map(String));
        } catch (e) {
          this.members[el.dataset.adlpMembers] = new Set();
        }
      });

      const params = new URLSearchParams(window.location.search);
      const validCats = this.chips.map((c) => c.dataset.adlpChip);
      const cat = params.get('cat') || '';
      this.state = {
        cat: validCats.indexOf(cat) > -1 ? cat : '',
        sort: params.get('sort') || 'best',
        limit: this.perPage,
      };
      if (this.sortSelect) {
        const has = Array.from(this.sortSelect.options).some((o) => o.value === this.state.sort);
        if (!has) this.state.sort = 'best';
        this.sortSelect.value = this.state.sort;
      }

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          this.state.cat = chip.dataset.adlpChip;
          this.state.limit = this.perPage;
          this.render(true);
        });
      });

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => {
          this.state.sort = this.sortSelect.value;
          this.state.limit = this.perPage;
          this.render(true);
        });
      }

      if (this.refineBtn && this.chipWrap) {
        this.refineBtn.addEventListener('click', () => {
          const open = this.refineBtn.getAttribute('aria-expanded') === 'true';
          this.refineBtn.setAttribute('aria-expanded', String(!open));
          this.chipWrap.hidden = open;
        });
      }

      if (this.moreBtn) {
        this.moreBtn.addEventListener('click', () => {
          const firstNew = this.state.limit;
          this.state.limit += this.perPage;
          this.render(false);
          const target = this.visible[firstNew];
          const link = target && target.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        });
      }

      this.items.forEach((li) => li.classList.remove('adlp-js-hide'));
      this.render(false);
    }

    sorted(list) {
      const by = {
        'price-asc': (a, b) => num(a, 'price') - num(b, 'price') || num(a, 'i') - num(b, 'i'),
        'price-desc': (a, b) => num(b, 'price') - num(a, 'price') || num(a, 'i') - num(b, 'i'),
        newest: (a, b) => num(b, 'new') - num(a, 'new') || num(a, 'i') - num(b, 'i'),
        best: (a, b) => num(a, 'i') - num(b, 'i'),
      };
      return list.slice().sort(by[this.state.sort] || by.best);
    }

    render(updateUrl) {
      const { cat, limit } = this.state;
      const set = cat ? this.members[cat] : null;
      const matches = this.items.filter((li) => !set || set.has(li.dataset.id));
      const ordered = this.sorted(matches);

      const frag = document.createDocumentFragment();
      ordered.forEach((li) => frag.appendChild(li));
      this.items.forEach((li) => {
        if (matches.indexOf(li) === -1) frag.appendChild(li);
      });
      this.grid.appendChild(frag);

      this.visible = ordered;
      const matchSet = new Set(matches);
      ordered.forEach((li, idx) => { li.hidden = idx >= limit; });
      this.items.forEach((li) => { if (!matchSet.has(li)) li.hidden = true; });

      this.chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.adlpChip === cat)));

      if (this.countEl) {
        this.countEl.textContent = matches.length + (matches.length === 1 ? ' product' : ' products');
      }
      if (this.emptyEl) this.emptyEl.hidden = matches.length > 0;

      if (this.moreBtn) {
        const remaining = Math.max(0, matches.length - limit);
        this.moreBtn.hidden = remaining === 0;
        this.moreBtn.textContent = 'Show ' + Math.min(remaining, this.perPage) + ' more';
      }

      if (updateUrl) {
        const url = new URL(window.location.href);
        if (cat) url.searchParams.set('cat', cat); else url.searchParams.delete('cat');
        if (this.state.sort !== 'best') url.searchParams.set('sort', this.state.sort);
        else url.searchParams.delete('sort');
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }
  }

  function num(el, key) {
    const v = parseFloat(el.dataset[key]);
    return isNaN(v) ? 0 : v;
  }

  customElements.define('adlp-shop-all', AdlpShopAll);
})();
